/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Error_TakeoverInputs */



/**
* | output |
* | --- |
* | "Failed to take over tournament" |
*
* @param {Offline_Error_TakeoverInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_error_takeover = /** @type {((inputs?: Offline_Error_TakeoverInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Error_TakeoverInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de la reprise du tournoi")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al tomar control del torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao assumir controle do torneio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile prendere controllo del torneo")
	return /** @type {LocalizedString} */ ("Failed to take over tournament")
});